import React__default, { useContext } from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { h as getClassName } from '../index-579ca9d7.js';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../utils/message/getOutgoingMessageState.js';
import '../index-6add7940.js';
function UnknownMessageItemBody(_ref) {
  var _message$reactions;
  var className = _ref.className,
    message = _ref.message,
    _ref$isByMe = _ref.isByMe,
    isByMe = _ref$isByMe === void 0 ? false : _ref$isByMe,
    _ref$mouseHover = _ref.mouseHover,
    mouseHover = _ref$mouseHover === void 0 ? false : _ref$mouseHover,
    _ref$isReactionEnable = _ref.isReactionEnabled,
    isReactionEnabled = _ref$isReactionEnable === void 0 ? false : _ref$isReactionEnable;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: getClassName([className, 'sendbird-unknown-message-item-body', isByMe ? 'outgoing' : 'incoming', mouseHover ? 'mouse-hover' : '', isReactionEnabled && (message === null || message === void 0 ? void 0 : (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length) > 0 ? 'reactions' : ''])
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-unknown-message-item-body__header",
    type: LabelTypography.BODY_1,
    color: isByMe ? LabelColors.ONCONTENT_1 : LabelColors.ONBACKGROUND_1
  }, stringSet.UNKNOWN__UNKNOWN_MESSAGE_TYPE), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-unknown-message-item-body__description",
    type: LabelTypography.BODY_1,
    color: isByMe ? LabelColors.ONCONTENT_2 : LabelColors.ONBACKGROUND_2
  }, stringSet.UNKNOWN__CANNOT_READ_MESSAGE));
}
export { UnknownMessageItemBody as default };